import classNames from "classnames";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { createUseStyles, useTheme } from "react-jss";
import { ErrorFallback } from "../../..";
import { ResponseContent } from "../ResponseContent";
import { timeHHMM } from "../../../../core";

const { isSaderatCustomization } = JSON.parse(sessionStorage.getItem("config"));

const useStyles = createUseStyles((theme) => ({
  messageContainer: {
    display: "flex",
    justifyContent: "flex-start",
    WebkitBoxPack: "start",
    alignItems: "flex-end",
  },
  avatar: {
    height: "100%",
    minWidth: "100%",
    transformOrigin: "bottom right",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    borderRadius: "50% 50% 0 50%",
  },
  botImage: {
    backgroundImage: "url(" + theme.avatarImage + ")",
  },
  operatorImage: {
    backgroundImage: "url(" + theme.operatorImage + ")",
  },
  botImageContainer: {
    height: 32,
    minWidth: 32,
  },
  bubbleContainer: {
    width: "100%",
    marginInlineStart: 8,
  },
  bubble: {
    borderRadius: "10px 10px 10px 0",
    background: `${
      isSaderatCustomization
        ? theme.answerBubbleBgSaderat
        : theme.answerBubbleBg
    }!important`,
    boxShadow: `0 1px 2px 0 ${theme.bubbleShadowColor}`,
    color: theme.answerBubbleColor,
    display: "inline-block",
    maxWidth: "75%",
    position: "relative",
    padding: "16px",
    transformOrigin: "bottom left",
  },
  time: {
    fontSize: 14,
    color: theme.chatTimeColor,
  },
  "@media screen and (min-width: 688px) ": {
    botImageContainer: {
      height: 40,
      minWidth: 40,
    },
  },
}));

const AnswerBubble = ({ message, chat_agent }) => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className={styles.messageContainer}>
        <div style={{ display: "inline-block", order: "0" }}>
          <div className={styles.botImageContainer}>
            <div
              alt="avatar"
              className={classNames(
                styles.avatar,
                chat_agent === "OPT" ? styles.operatorImage : styles.botImage
              )}
            />
          </div>
        </div>
        <div className={styles.bubbleContainer}>
          <div className={styles.bubble}>
            <ResponseContent response={message} />
          </div>
          <div className={styles.time}>{timeHHMM(message.question_date)}</div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export { AnswerBubble };
